import { defineTokens } from '@chakra-ui/react/styled-system';

// Numeric, pixel-valued to match the size/spacing token convention (1 = 1px, 2 = 2px).
// `borderWidth` resolves against this `borderWidths` scale — without it, raw values like
// `'1px'` are passed through unresolved (and a bare `'1'` would emit invalid unitless CSS).
const borderWidths = defineTokens.borderWidths({
  '1': {
    value: '1px',
  },
  '2': {
    value: '2px',
  },
  '3': {
    value: '3px',
  },
  '4': {
    value: '4px',
  },
});

export default borderWidths;
